import { gql } from 'urql';
import { PRODUCT } from '../client';

export const ESCALATE_STOPS_TO_PROVIDER = gql`
  mutation ${PRODUCT}EscalateStopsToProvider($input: EscalateStopsToProviderInput!) {
    escalateStopsToProvider(input: $input) {
      route {
        id
        name
        nightEnd
        thirdPartyProvider
        redeliveryStops {
          id
          deliveryStatusDmp
          deliveryStop {
            id
          }
        }
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
